import { createTheme } from '@mui/material/styles';
import shippoTheme from '../../styles/shippoTheme.js';

var AccordionDetailsTheme = createTheme(shippoTheme, {
    components: {
        MuiAccordionDetails: {
            styleOverrides: {
                root: {
                    paddingLeft: '0',
                    paddingRight: '0',
                },
            },
        },
    },
});

export { AccordionDetailsTheme as default };
//# sourceMappingURL=AccordionDetails.theme.js.map
